/* 
 * Copyright (c) 2023 IQVIA Corp.  All Rights Reserved
 */
/* eslint-disable no-console */
import axios from 'axios';

export const getLocalVariable = (key) => window.localStorage.getItem(key);
let _config;

export const loadConfig = async () => {
  if (!_config) {
    try {
      const response = await axios.get('/environment.json', { headers: { 'content-type': 'application/json' } });
      _config = response?.data;
      console.log('Environment Configuration Successfully Loaded.');
    } catch (err) {
      return null;
    }
    return _config;
  }
};
